export const ALL_TABS: { value: ParticipantsTab; label: string }[] = [
  { value: 'Participating', label: 'Подтвердившие' },
  { value: 'JoinRequest', label: 'Заявки' },
  { value: 'Invited', label: 'Приглашенные' },
  { value: 'Exited', label: 'Вышедшие' },
  // Removed - удаленные после начала турнира
  { value: 'Removed', label: 'Удаленные' },
  // Deleted - удаленные до начала турнира
  { value: 'Deleted', label: 'Удаленные' },
  { value: 'Banned', label: 'Забаненные' },
];

export type ParticipantsTab =
  | 'Participating'
  | 'Invited'
  | 'Exited'
  | 'Banned'
  | 'Removed'
  | 'Deleted'
  | 'JoinRequest';
